// Because there are all brand names, it is unnecessary for them to be translatable.
export default [
  { tag: 'scratch', intlLabel: 'Scratch', url: '' }, // Scratch不需要url,他也没有
  { tag: 'tw', intlLabel: 'TurboWarp', url: 'https://extensions.turbowarp.org/' },
  { tag: 'ae', intlLabel: 'AstraEditor', url: 'https://editors.astras.top/extensions' }
];
